// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/market_catalog",
    element: lazy(() => import("../pages/MarketCatalog/index.js")),
  },
  {
    path: "/add_market_catalog",
    element: lazy(() => import("../pages/MarketCatalog/AddMarketCatalog")),
  },
];

export default routes;
